export function ShortcutHint({ keys }: { keys: string[] }) {
  return (
    <span className="shortcut-hint" aria-hidden="true">
      {keys.map((key) => <kbd key={key}>{key}</kbd>)}
    </span>
  );
}
